export default __webpack_public_path__ + "static/media/icon-suggest.392e0b41.svg";